<template>
  <div class="h-100">
    <RPTrage v-if="isRPTradeModule" />
    <Reports v-if="isReportModule || isONEProject" />
    <Tickets v-if="isTicketProject" />
  </div>
</template>

<script>
import { LicenseMixin } from '../../mixins';
import RPTrage from './components/RPTrage/index';
import Reports from '../../v2/components/dashboard/Reports';
import Tickets from '../../v2/components/dashboard/Tickets';

export default {
  name: 'Dashboard',
  components: { RPTrage, Reports, Tickets },
  mixins: [LicenseMixin],
};
</script>
